import { render, staticRenderFns } from "./ParentButton.vue?vue&type=template&id=077cc02c&"
import script from "./ParentButton.vue?vue&type=script&lang=js&"
export * from "./ParentButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports